import axios from 'axios';
import store from "@/store";

const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: true,
    timeout: 5000, // set the default timeout for requests to 5 seconds
});

instance.interceptors.request.use(function (config) {
    let currency = null;
    try {
        const currencyStr = localStorage.getItem('currency');
        currency = currencyStr ? JSON.parse(currencyStr) : null;
    } catch (e) {
        console.error('Failed to parse currency from localStorage:', e);
    }
    
    // Fallback to EUR if no valid currency
    if (!currency || !currency.code) {
        currency = {"code":"EUR","symbol":"€"};
    }

    const lang_id = store.getters['app/currentLanguage'];

    if (config.method === 'get') {
        config.params = {
            ...config.params,
            lang_id,
            currency: currency.code
        }

        config.params['lang_id'] = lang_id;
    } else if (['post', 'put', 'patch', 'POST', 'PUT', 'PATCH'].includes(config.method)) {
        if (config.data instanceof FormData) {
            config.data.append('currency', currency.code)
        } else {
            config.data = {
                ...config.data,
                currency: currency.code,
                lang_id
            }
        }
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default instance;